export const PRODUCTION_API_ORIGIN = 'https://api.signalbridges.com';

export function isProductionApiHost(hostname) {
  const host = String(hostname || '').toLowerCase();
  return host === 'app.signalbridges.com' || host.endsWith('.signalbridges.com');
}

function originOverride() {
  try {
    return String(import.meta.env.VITE_API_ORIGIN || '').replace(/\/+$/, '');
  } catch {
    return '';
  }
}

/**
 * Production Signal Bridge pages call the API hostname.
 * Local development keeps a relative /api path for the Vite proxy.
 * Absolute URLs, including signed storage and third-party hosts, are unchanged.
 * VITE_API_URL stays a local fallback and cannot move production back to Cloud Run.
 */
export function backendApiUrl(
  path,
  hostname = typeof window !== 'undefined' ? window.location.hostname : ''
) {
  const raw = String(path || '');
  if (/^https?:\/\//i.test(raw)) return raw;
  if (!(raw.startsWith('/api/') || raw === '/api')) return raw;

  const override = originOverride();
  const origin = override || (isProductionApiHost(hostname) ? PRODUCTION_API_ORIGIN : '');
  if (!origin) return raw;
  return `${origin.replace(/\/api$/i, '')}${raw}`;
}
